export default __webpack_public_path__ + "static/media/paysera.b88d3a41.png";